import React from 'react';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import VerificationResent from './VerificationResent';
import VerificationNeeded from './VerificationNeeded';
export const VerificationReminder = ({ email, isUnverified, resendEmail, isEmailChangeInProgress, isResendInProgress, isSendingDone, hideChangeEmail })=>{
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        themeSurface: ThemeSurface.TERTIARY
    }, isSendingDone ? /*#__PURE__*/ React.createElement(VerificationResent, {
        email: email
    }) : /*#__PURE__*/ React.createElement(VerificationNeeded, {
        email,
        isUnverified,
        resendEmail,
        isEmailChangeInProgress,
        isResendInProgress,
        hideChangeEmail
    }));
};
VerificationReminder.displayName = 'VerificationReminder';
export default VerificationReminder;
